import React from "react";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { ScrollableView } from "@remo-co/ui-core/src/components/ScrollableView";
import EditProfileContainer from "modules/userProfileForm/EditProfileContainer";
import { useStyles } from "./styles";
import ProfileInfo from "./ProfileInfo";

const ProfileView = () => {
  const [isEdit, setIsEdit] = React.useState(false);

  const classes = useStyles();

  const handleEdit = () => {
    setIsEdit(true);
  };
  const handleDoneEdit = () => {
    setIsEdit(false);
  };

  return (
    <ScrollableView withAppBar={false} className={classes.scrollable}>
      <Box className={classes.box}>
        {!isEdit && <ProfileInfo onEdit={handleEdit} />}
        {isEdit && (
          <EditProfileContainer
            onClose={handleDoneEdit}
            onSaved={handleDoneEdit}
          />
        )}
      </Box>
    </ScrollableView>
  );
};

export default ProfileView;
